import * as Long from "long";
import { utilNumber } from "../utils/utilNumber";
import { selectPlayerInfo } from "./selectPlayerInfo";
export var selectAppsflyerData = function (state, eventName, eventValue) {
    var playerId = selectPlayerInfo(state).playerId;
    var mobileTrackingId = state.playerSettingsInfo.mobileTrackingId;
    if (mobileTrackingId === undefined) {
        return;
    }
    return {
        appsflyer_id: mobileTrackingId,
        eventName: eventName,
        eventValue: eventValue,
        playerId: utilNumber.format(playerId || Long.ZERO),
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectAppsflyerData.ts
// module id = 1781
// module chunks = 3